module.exports = __webpack_public_path__ + "mobile/img/img4-618.fbb5f35d.png";